import React from 'react';

import Qualifications from 'components/Qualifications';

const CustomerQualifications = ({ id }) => {
  return <Qualifications id={id} type="User" />;
};

export default CustomerQualifications;
